<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">

    <!-- modal for post delete -->
    <transition mode="out-in" name="fade">
      <modal @close="showModal = false" :kind="kind" @confirmLogout='confirmLogout()' v-if="showModal" :header="header"/>
    </transition>

    <div class="navbar-brand">
      <a class="navbar-item" href="/admin">
        <img src="/static/img/TheAdmin-logo-icon-color.svg" width="112" height="28">
      </a>
    </div>

    <div class="navbar-menu">
      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <a class="button is-light" @click="signOut">
              {{currentUser.email}}<i class="fa fa-sign-out" style="margin-left: 12px;"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import firebase from 'firebase'
import modal from '@/admin/components/shared/Modal'
export default {
  name: 'navbar',
  data () {
    return {
      mobileMenuIsActive: false,
      currentUser: firebase.auth().currentUser,
      showModal: false,
      header: 'Êtes-vous certain de vous déconnecter?',
      kind: 'logout'
    }
  },
  methods: {
    signOut () {
      this.showModal = true
    },
    confirmLogout () {
      // sign the current user out
      firebase.auth().signOut()
        .then(() => {
          this.showModal = false
          this.$router.push('/')
        })
        .catch(() => {
          console.log('sign out fails')
        })
    },
    toggleMenu () {
      this.mobileMenuIsActive = !this.mobileMenuIsActive
    }
  },
  components: {
    modal
  }
}

</script>

<style lang="scss" scoped>
@media screen and (max-width: 1088px){
  .bulma .navbar-menu{
    display: contents;
    .navbar-item{
      padding-top: 0 !important;
    }
  }
  .bulma .navbar-brand .navbar-item{
    display: inline-block;
    width: 100%;
    text-align: center;
    padding-bottom: 0 !important;
    max-height: none;
    img{
      height:100%;
    }
  }
  .bulma .buttons{
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/admin/components/layout/Navbar.vue